export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: "全部",
    },
    {
      value: 0,
      name: "In",
      text: "內用",
    },
    {
      value: 1,
      name: "Out",
      text: "外帶",
    },
    {
      value: 2,
      name: "Delivery",
      text: "外送",
    },
    {
      value: 3,
      name: "InAndOut",
      text: "內用&外帶",
    },
    {
      value: 4,
      name: "InAndDelivery",
      text: "內用&外送",
    },
    {
      value: 5,
      name: "OutAndDelivery",
      text: "外帶&外送",
    },
    {
      value: 6,
      name: "PickSelf",
      text: "自取",
    },
    {
      value: 7,
      name: "InAndPickSelf",
      text: "內用&自取",
    },
    {
      value: 8,
      name: "OutAndPickSelf",
      text: "外帶&自取",
    },
    {
      value: 9,
      name: "DeliveryAndPickSelf",
      text: "外送&自取",
    },
    {
      value: 10,
      name: "InAndOutAndDelivery",
      text: "內用&外帶&外送",
    },
    {
      value: 11,
      name: "InAndOutAndPickSelf",
      text: "內用&外帶&自取",
    },
    {
      value: 12,
      name: "InAndDeliveryAndPickSelf",
      text: "內用&外送&自取",
    },
    {
      value: 13,
      name: "OutAndDeliveryAndPickSelf",
      text: "外帶&外送&自取",
    },
  ];
}
